<template>
	<div class="modal animated fadeIn" id="register-form" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
		<div class="modal-close-container">
			<button id="close" onclick="document.getElementById('register-form').style.display='none';" type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header text-center">
					<h4 class="modal-title w-100">Registrirajte se</h4>
				</div>
				<div class="modal-body mx-3 text-center">
					<!-- <form id="login-form-fb" action="" method="post"> -->
					<div class="input-group mb-3">
						<!-- <button id="submit" name="submit" type="submit" class="fs-btn fb text-uppercase btn-lg btn-block">Registriraj se preko facebooka</button> -->
						<!-- <facebook-login class="button"
                        appId="606396993332867"
                        @login="getUserData"
                        @logout="onLogout" 
                        @sdk-loaded="sdkLoaded"
                        >
                        </facebook-login> -->
					</div>
					<!-- </form> -->
					<form @submit="createAccount($event)" class="mb-5">
						<div v-if="!closeForm">
							<div class="input-group mb-3">
								<input id="email" v-model="user.email" type="email" class="form-control" placeholder="E-adresa" aria-label="email" aria-describedby="basic-addon1" required>
							</div>
							<div class="input-group mb-3">
								<input id="name" v-model="user.name" type="text" class="form-control" placeholder="Username" aria-label="name" aria-describedby="basic-addon1" required>
							</div>
							<div class="input-group mb-3">
								<input id="password" v-model="user.password" type="password" class="form-control" placeholder="Lozinka" aria-label="password" aria-describedby="basic-addon2" required>
							</div>
							<div class="input-group mb-2">
								<div class="form-check text-left">
									<input class="form-check-input mr-1" type="checkbox" id="agree" required>
									<label id="agree-label" class="form-check-label modal-text" for="agree">
										Prihvaćam
										<a class="agree-tac" href="/uvjeti">Uvjete i pravila korištenja</a>
									</label>
								</div>
							</div>
						</div>
						<notify></notify>
						<button v-if="!closeForm" id="submit" name="submit" type="submit" class="fs-btn primary text-uppercase btn-lg">
							<loaderCircle v-if="loader"></loaderCircle>
							<span v-else> Registrirajte se </span>
						</button>
					</form>
					<!-- <p><a href="#" style="color:black;font-weight:bold" data-dismiss="modal" data-toggle="modal" data-target="#register-vendor-form">Registracija salona</a></p> -->
					<p class="modal-text">Imate korisnički račun? <a href="#" data-dismiss="modal" data-toggle="modal" data-target="#login-form">Prijavite se!</a></p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapMutations
	} from 'vuex'
	export default {
		name: 'signupmodal',
		data: () => {
			return {
				user: {
					name: '',
					email: '',
					password: '',
				},
				closeForm: false
			}
		},
		computed: {
			...mapState({
				endpoint: (state) => state.endpoint,
				notification: (state) => state.notification,
				loader: (state) => state.loader,
			}),
		},
		methods: {
			...mapMutations({
				setNotif: 'setNotification',
				setLoader: 'setLoader',
				handleError: 'handleError'
			}),
			sdkLoaded(payload) {
				console.log(payload);
				this.FB = payload.FB;
				console.log('loaded');
			},
			getUserData(data) {
				console.log(data);

				this.FB.api('/me', 'GET', {
						fields: 'id,name,email,picture'
					},
					user => {
						console.log(user);
					});
				console.log(this.result);
			},
			onLogout() {},
			createAccount(e) {
				e.preventDefault();

				for (var item in this.user) {
					if (this.user[item].length == 0) {
						this.setNotif({
							type: 2,
							msg: "Sva polja su obavezna!"
						});
						return false;
					}
				}

				if (!window.$("#agree").is(':checked')) {
					this.setNotif({
						type: 2,
						msg: "Potvrdite da ste pročitali i da se slažete s pravilima i uvjetima korištenja."
					});
					return false;
				}
				this.setLoader(true);
				this.$store.dispatch('post', {
						details: this.user,
						endpoint: this.endpoint + 'signup'
					})
					.then((data) => {
						// console.log(data);
						this.setNotif({
							type: 1,
							msg: data.data.msg
						});
						this.closeForm = true;
						this.setLoader(false);
						document.getElementById('removeModal').click();
						window.$("#login-form").modal('show');
					})
					.catch((error) => {
						console.log(error.request);
						if (error.request != null) {
							this.$store.dispatch("handleError", error);
						}
						this.setLoader(false);
					});
			}
		},
		created() {}
	}

</script>
